import type { EventData } from '@ori-events/open-subscription-wizard';
import openSubscriptionEvent from '@ori-events/open-subscription-wizard';
import { useCallback, useEffect, useState } from 'react';

import { EWizardCustomerType } from '~/shared/types/EWizardCustomerType';
import type { WizardContext } from '~/shared/types/WizardContext';

export function useOpenEvent() {
  const [open, setOpen] = useState(false);
  const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);
  const [key, setKey] = useState(0);
  const [customerType, setCustomerType] = useState<WizardContext['customerType']>(null);

  const [wizardType, setWizardType] = useState<WizardContext['wizardType']>(null);
  const [productCode, setProductCode] = useState<WizardContext['productCode']>();

  const handleOpenEvent = useCallback(
    ({
      detail: {
        customerType: initialCustomerType = EWizardCustomerType.All,
        productCode: code,
        type: initialWizardType,
      },
    }: CustomEvent<EventData>) => {
      setCustomerType(EWizardCustomerType[initialCustomerType]);
      setWizardType(initialWizardType);
      setProductCode(code);
      setOpen(true);
      setKey((current) => current + 1);
    },
    [],
  );

  const handleOpenFeedback = () => {
    setIsFeedbackOpen(true);
  };

  const handleCloseFeedback = () => {
    setIsFeedbackOpen(false);
  };

  useEffect(() => {
    openSubscriptionEvent.listen(handleOpenEvent);

    return () => {
      openSubscriptionEvent.clean(handleOpenEvent);
    };
  }, [handleOpenEvent, customerType]);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  return {
    open,
    customerType,
    wizardType,
    productCode,
    key,
    handleClose,
    handleCloseFeedback,
    handleOpenFeedback,
    isFeedbackOpen,
  } as const;
}
